if ( typeof QuickAddToCart !== 'function' ) {

	const CartState = {
		_items: new Map(),
		_listeners: new Set(),
		_pending: null,

		refresh() {
			if (this._pending) return this._pending;
			this._pending = fetch('/cart.js', { credentials: 'same-origin' })
				.then(r => r.json())
				.then(cart => {
					this._items.clear();
					cart.items.forEach(item => {
						const vid = String(item.variant_id);
						const existing = this._items.get(vid);
						if (existing) {
							existing.quantity += item.quantity;
						} else {
							this._items.set(vid, { quantity: item.quantity, key: item.key });
						}
					});
					this._listeners.forEach(fn => fn());
				})
				.finally(() => { this._pending = null; });
			return this._pending;
		},

		getInfo(variantId) {
			return this._items.get(String(variantId)) || null;
		},

		subscribe(fn) {
			this._listeners.add(fn);
		}
	};

	CartState.refresh();
	document.addEventListener('cart-updated', () => CartState.refresh());

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}

		init(){
			this.variantId = this.dataset.variantId;
			this.addBtnWrap = this.querySelector('.quick-add-to-cart-button');
			this.stepper = this.querySelector('[data-qty-stepper]');
			this.qtyDisplay = this.querySelector('.qty-stepper__value');
			this.isWorking = false;

			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					// Don't open cart drawer for quick add - only update cart content
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]')?.textContent || '';
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]')?.textContent || '';
						});
						const cartRec = this.closest('cart-recommendations');
						if ( cartRec ) {
							const productItem = this.closest('.product-item');
							const productId = productItem && productItem.dataset.productId;
							if ( productId ) {
								const cartItems = document.querySelectorAll(`#AjaxCartForm [data-js-cart-item][data-product-id="${productId}"]`);
								const cartItem = cartItems.length > 0 ? cartItems[cartItems.length - 1] : null;
								if ( cartItem ) {
									const cartLine = cartItem.dataset.line;
									const cartKey = cartItem.dataset.id;
									const cartQty = cartItem.dataset.qty || '1';
									const decLabel = (KROWN.settings.locales && KROWN.settings.locales.decrease_quantity) || 'Decrease';
									const incLabel = (KROWN.settings.locales && KROWN.settings.locales.increase_quantity) || 'Increase';
									const qtyEl = document.createElement('cart-recommendation-quantity');
									qtyEl.className = 'cart-recommendation-quantity';
									qtyEl.dataset.cartLine = cartLine;
									if ( cartKey ) qtyEl.dataset.cartKey = cartKey;
									qtyEl.dataset.productId = productId;
									qtyEl.dataset.quickAddRef = 'true';
									qtyEl.innerHTML = '<button type="button" class="cart-recommendation-qty-btn cart-recommendation-qty-minus" aria-label="' + decLabel + '">−</button><span class="cart-recommendation-qty-value">' + cartQty + '</span><button type="button" class="cart-recommendation-qty-btn cart-recommendation-qty-plus" aria-label="' + incLabel + '">+</button>';
									this.style.display = 'none';
									this.parentNode.insertBefore(qtyEl, this);
									productItem.classList.remove('working');
								}
							}
						} else if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if (typeof interceptCheckoutButtons === 'function') {
							setTimeout(interceptCheckoutButtons, 1200);
						}
						if (typeof window.initFlippableNutritionCard === 'function') {
							const cartCard = document.getElementById('cart-nutrition-card');
							const drawerCard = document.getElementById('drawer-nutrition-card');
							if (cartCard) window.initFlippableNutritionCard('cart-nutrition-card');
							if (drawerCard) window.initFlippableNutritionCard('drawer-nutrition-card');
						}
						const event = new Event('cart-updated');
						document.dispatchEvent(event);
					};
				}
			});

			if (this.stepper) {
				this.querySelector('.qty-stepper__minus').addEventListener('click', e => {
					e.preventDefault();
					e.stopPropagation();
					this.decrease();
				});
				this.querySelector('.qty-stepper__plus').addEventListener('click', e => {
					e.preventDefault();
					e.stopPropagation();
					this.increase();
				});
			}

			CartState.subscribe(() => this.updateDisplay());
		}

		updateDisplay(){
			if (!this.stepper) return;
			const info = CartState.getInfo(this.variantId);
			if (info && info.quantity > 0) {
				this.addBtnWrap.style.display = 'none';
				this.stepper.style.display = '';
				this.qtyDisplay.textContent = info.quantity;
			} else {
				this.addBtnWrap.style.display = '';
				this.stepper.style.display = 'none';
			}
			this.isWorking = false;
			this.stepper.classList.remove('working');
		}

		increase(){
			if (this.isWorking) return;
			this.isWorking = true;
			this.stepper.classList.add('working');
			const submitBtn = this.querySelector('form [type="submit"]');
			if (submitBtn) submitBtn.click();
		}

		decrease(){
			if (this.isWorking) return;
			const info = CartState.getInfo(this.variantId);
			if (!info) return;

			this.isWorking = true;
			this.stepper.classList.add('working');

			const newQty = info.quantity - 1;

			fetch(KROWN.settings.routes.cart_change_url, {
				method: 'POST',
				headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
				body: JSON.stringify({ id: info.key, quantity: newQty })
			})
				.then(() => fetch('?section_id=helper-cart'))
				.then(r => r.text())
				.then(text => {
					const doc = new DOMParser().parseFromString(text, 'text/html');

					const cartForm = document.getElementById('AjaxCartForm');
					if (cartForm) {
						cartForm.innerHTML = doc.getElementById('AjaxCartForm').innerHTML;
						cartForm.ajaxifyCartItems();
					}

					const cartSubtotal = document.getElementById('AjaxCartSubtotal');
					if (cartSubtotal) {
						cartSubtotal.innerHTML = doc.getElementById('AjaxCartSubtotal').innerHTML;
					}

					document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
						const src = doc.querySelector('[data-cart-count]');
						if (src) elm.textContent = src.textContent;
					});
					document.querySelectorAll('[data-header-cart-total').forEach(elm => {
						const src = doc.querySelector('[data-cart-total]');
						if (src) elm.textContent = src.textContent;
					});

					if (typeof interceptCheckoutButtons === 'function') {
						setTimeout(interceptCheckoutButtons, 700);
					}

					document.dispatchEvent(new Event('cart-updated'));
				})
				.catch(() => {
					CartState.refresh();
				});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

				} else {
					this.quickViewModal.show();
				}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}
